import { Button, Input } from 'semantic-ui-react';
import { Numpad } from '../../../components/helpers/numpad';

const StepParentIdentification = (props) => {
  const { loading, inputs, handleInputs, getInfo, setInputs } = props;

  const setPressedIdentification = (key) => {
    if (key === 'del') {
      setInputs({
        ...inputs,
        identification: Number(String(inputs.identification || '').slice(0, -1)) || '',
      });
      return;
    }
    if (key === 'clear') {
      setInputs({ ...inputs, identification: '' });
      return;
    }
    setInputs({ ...inputs, identification: Number(String(inputs.identification || '') + key) });
  };

  return (
    <>
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
          getInfo();
        }}
      >
        <label htmlFor="identification">Escribe la cédula del acudiente</label>
        <Input
          loading={loading}
          name={'identification'}
          id={'identification'}
          type="number"
          onChange={handleInputs}
          value={inputs.identification}
          placeholder="Cédula acudiente"
        />
        <Button type="submit">Ir</Button>
        <Numpad pressed={setPressedIdentification} />
      </form>
    </>
  );
};

export default StepParentIdentification;
